class QuickView extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.vsp = window.vsp || {};
    window.vsp.quickView = this;
    this.hasUpdated = false;
  }
  disconnectedCallback() {
  }
  updateAndShow(url) {
    console.log("updateAndShow", url);
    this.update(url);
    vsp.showOverlay("quick-view");
  }
  update(url) {
    this.setAttribute("data-state", "loading");
    if (!this.hasUpdated) {
      var link = document.createElement("link");
      link.href = this.getAttribute("data-style");
      link.type = "text/css";
      link.rel = "stylesheet";
      document.getElementsByTagName("head")[0].appendChild(link);
      this.hasUpdated = true;
      this.productContainer = this.querySelector(".quick-view-product");
      this.loadingState = this.querySelector(".loading-state");
    }
    fetch(url).then((response) => response.text()).then((responseText) => {
      const responseHTML = document.createRange().createContextualFragment(responseText);
      const html = responseHTML.querySelector("main > .shopify-section");
      html.querySelector(".desktop-photos-wrap").remove();
      html.querySelector(".item-photos.mobile-only").classList.remove("mobile-only");
      html.querySelector(".condition-graph-wrap a").removeAttribute("href");
      html.querySelector(".condition-graph-wrap a").removeAttribute("data-show-overlay");
      html.querySelectorAll(".product-bar").forEach((el) => {
        el.remove();
      });
      html.querySelectorAll(".product-page-accordian-item[data-topic='authenticity']").forEach((el) => {
        el.remove();
      });
      html.querySelectorAll(".product-page-accordian-item").forEach((el) => {
        el.removeAttribute("open");
      });
      html.querySelector(".view-full-product-details-for-quickview").style.display = "block";
      this.productContainer.replaceChildren(html);
      this.setAttribute("data-state", "viewing");
      if (vsp.product) {
        vsp.product();
      }
      console.log("window.swat", window.swat);
      if (window.swat && vsp.productPageWishlist) {
        vsp.productPageWishlist(swat);
      }
      if (Shopify.AjaxifyCart) {
        Shopify.AjaxifyCart.init();
      }
    });
  }
}
if (!customElements.get("quick-view")) {
  customElements.define("quick-view", QuickView);
}
